export default __webpack_public_path__ + "static/media/404.e12792f5.svg";